/**
 * Role enum + permission helpers.
 * Mirrors the role values stored in JWT app_metadata.role.
 */

export type Role =
  | 'cleaner'
  | 'maintenance'
  | 'supervisor'
  | 'contractor_admin'
  | 'client_view'
  | 'super_admin'
  // PROJECT_STATE task #76 — owner-side approver who decides
  // additional-fee requests submitted by cleaners. Separate from
  // contractor_admin so the contracting party (client) can sit
  // inside the tenant org without inheriting admin powers.
  | 'owner_approver'

export const ALL_ROLES: readonly Role[] = [
  'cleaner',
  'maintenance',
  'supervisor',
  'contractor_admin',
  'client_view',
  'super_admin',
  'owner_approver',
] as const

export function isValidRole(v: unknown): v is Role {
  return typeof v === 'string' && (ALL_ROLES as readonly string[]).includes(v)
}
